import { View } from "binder"
import { GuageElement } from "./guage-viewModel";

export class GuageView extends View<GuageElement>{
    GetViewUniqueId(): string {
        return "V-957A2690-27AE-404B-B9EE-B9E56760A07F"
    }
    loadHtml(): string {
        let element = require('./guage.html').default;
        let style = require('./guage.less');
        return element;
    }
    constructor() {
       super();
    }
}
